import React from 'react'
import {
    SectionContainer,
    SectionTitle,
    ProductScrollContainer,
    ProductScrollItem,
} from './Shared'
import { useRecentlyViewedProducts } from '../../../hooks/useRecentlyViewedProducts'
import { ItemsGrid } from '../full-screen/PLPDrawer'
import { useColumnCount } from '../../../context/ProductLayoutContext'

export const RecentlyViewedSection: React.FC = () => {
    const products = useRecentlyViewedProducts(10)
    const columnCount = useColumnCount()

    // Don't show section if no products
    if (products.length === 0) {
        return null
    }

    return (
        <SectionContainer>
            <SectionTitle isHorizontalScroll={true}>
                Recently Viewed
            </SectionTitle>
            <ProductScrollContainer>
                {products.map((product) => (
                    <ProductScrollItem key={product.linkHash}>
                        <ItemsGrid
                            landingPageLinks={[product]}
                            columnCount={columnCount}
                            isHorizontalScroll={true}
                        />
                    </ProductScrollItem>
                ))}
            </ProductScrollContainer>
        </SectionContainer>
    )
}
